import { activityType } from '@repo/shared/types';
import { isPragmaPromoted } from './is-pragma-promoted';
import { isLiberisPromoted } from './is-liberis-promoted';
import { isOnlyPragmaAvailable } from './is-only-pragma-available';
import { isOnlyLiberisAvailable } from './is-only-liberis-available';
/**
 * Wylicza nextActivity dla eventu z activity OFFERS_VIEW na podstawie dostępnych
 * i promowanych providerów:
 *  - tylko pragma / multi z promowaną pragmą  → PRAGMA_SUMMARY_ACCEPT
 *  - tylko liberis / multi z promowanym liberisem → LIBERIS_PERSONS_DETAILS
 *  - multi bez promowania → null
 */
export var getOffersViewNextActivity = function (merchantResponse) {
    if (isOnlyPragmaAvailable(merchantResponse) || isPragmaPromoted(merchantResponse)) {
        return activityType.enum.PRAGMA_SUMMARY_ACCEPT;
    }
    if (isOnlyLiberisAvailable(merchantResponse) || isLiberisPromoted(merchantResponse)) {
        return activityType.enum.LIBERIS_PERSONS_DETAILS;
    }
    return null;
};
